
export const GET_SINGLE_NODE_TYPE_REQUEST = 'GET_SINGLE_NODE_TYPE_REQUEST'
export const GET_SINGLE_NODE_TYPE_SUCC = 'GET_SINGLE_NODE_TYPE_SUCC'
export const GET_SINGLE_NODE_TYPE_FAIL = 'GET_SINGLE_NODE_TYPE_FAIL'